import { useState } from "react";

import { Card, Grid, Typography } from "@mui/material";

import { CampaignAnalyticsService } from "@analytics/index";

import useFilteredEmails, { StatusesType } from "@hooks/useFilteredEmails";

import { CampaignType } from "@interfaces/campaign.type";

import CardContacts from "@pages/Campaigns/components/EngagementAndLeadCards/CardContacts";

import theme from "@theme/index";

import CardHeader from "./CardHeader";

interface IEngagementAndLeadCardsProperties {
  campaign: CampaignType;
  clickedEmails: number;
  openedEmails: number;
  repliedEmails: number;
}

export default function EngagementAndLeadCards({
  campaign,
  clickedEmails,
  openedEmails,
  repliedEmails,
}: IEngagementAndLeadCardsProperties) {
  const [activeSection, setActiveSection] = useState<StatusesType>("opened");

  const handleSetActiveSection = (section: StatusesType) => {
    setActiveSection(section);
  };

  const { emails } = campaign;

  const filteredEmails = useFilteredEmails(emails, activeSection);
  const emailWithInteractions = emails.filter((email) => email.linkClicked || email.opened || email.replyReceived);
  const emailWithLeads = emails.filter((email) => email.status.lead);

  const shouldShowEngagements = emailWithInteractions.length > 0;
  const shouldShowLeads = emailWithLeads.length > 0;

  if (!clickedEmails && !openedEmails && !repliedEmails) {
    return null;
  }

  return (
    <Grid container spacing={2}>
      {shouldShowEngagements && (
        <Grid item xs={shouldShowLeads ? 6 : 12}>
          <Card
            sx={{
              backgroundColor: theme.palette.grey[50],

              color: theme.palette.primary.contrastText,
              display: "flex",
              flexDirection: "column",
              gap: 3,
              height: "300px",
              overflowY: "hidden",
              padding: 3,
            }}
          >
            <CardHeader
              activeSection={activeSection}
              hasClicked={!!clickedEmails}
              hasOpened={!!openedEmails}
              hasResponded={!!repliedEmails}
              setActiveSection={handleSetActiveSection}
              shouldShowToggleButtons
              title="Engagements"
            />
            <Typography
              fontWeight={700}
              sx={{
                borderBottom: `1px solid ${theme.palette.grey[400]}`,
                pb: 0.5,
              }}
              variant="caption"
            >
              Contact
            </Typography>
            <CardContacts activeSection={activeSection} campaignId={campaign.id} emails={filteredEmails} />
          </Card>
        </Grid>
      )}

      {shouldShowLeads && (
        <Grid item xs={6}>
          <Card
            sx={{
              backgroundColor: theme.palette.grey[50],
              color: theme.palette.primary.contrastText,
              display: "flex",
              flexDirection: "column",
              gap: 3,
              height: "300px",
              overflowY: "hidden",
              padding: 3,
            }}
          >
            <CardHeader title="Leads" />
            <Typography
              fontWeight={700}
              sx={{
                borderBottom: `1px solid ${theme.palette.grey[400]}`,
                pb: 0.5,
              }}
              variant="caption"
            >
              Contact
            </Typography>
            <CardContacts
              activeSection={activeSection}
              campaignId={campaign.id}
              emails={emails}
              isLeadCard
              shouldShowNumbers={false}
            />
          </Card>
        </Grid>
      )}
    </Grid>
  );
}
